module.exports = __webpack_public_path__ + "static/media/blogThree.b5a1ffcc.webp";